/* ============================================================
   minimal-product.js — PDP ZARA 100 ml (Serené)
   - Reparte product.description por encabezados en negrita
   - Tabs (mobile) + acordeones
   - Galería: zoom desktop + indicador de carrusel mobile
   - Barra sticky mobile (IntersectionObserver)
   - Estados cosméticos del botón (add-to-cart es nativo del tema)
   Aislado: sólo actúa dentro de .mp-root. No toca el carrito (lo maneja
   el <product-form> nativo del tema).
   ============================================================ */
(function () {
  'use strict';

  function norm(s) {
    return (s || '')
      .toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[:\s]+$/, '')
      .trim();
  }

  var HEADER_MAP = {
    'descripcion': 'desc',
    'notas olfativas': 'notas',
    'notas': 'notas',
    'a que huele': 'smell',
    'cuando usarlo': 'uso',
    'personalidad': 'personalidad'
  };

  /* ---------- Parseo de la descripción ---------- */
  function parseDescription(sourceEl) {
    var out = { desc: '', notas: [], smell: '', uso: '', personalidad: '' };
    if (!sourceEl) return out;
    var nodes = Array.prototype.slice.call(sourceEl.childNodes);
    var current = null;

    nodes.forEach(function (node) {
      if (node.nodeType !== 1) {
        if (current && node.nodeType === 3 && node.textContent.trim()) {
          appendText(out, current, node.textContent.trim());
        }
        return;
      }
      var strong = node.querySelector ? node.querySelector('strong, b') : null;
      var isHeader = strong && /:\s*$/.test(strong.textContent);

      if (isHeader) {
        var key = HEADER_MAP[norm(strong.textContent)];
        current = key || null;
        // Valor que viene en el mismo <p> tras el <strong> y el <br>
        var clone = node.cloneNode(true);
        var s = clone.querySelector('strong, b');
        if (s) s.remove();
        var rest = clone.innerHTML.replace(/^\s*(<br\s*\/?>)+/i, '').trim();
        if (current && rest) appendHTML(out, current, rest);
      } else if (current) {
        if (node.tagName === 'UL' || node.tagName === 'OL') {
          Array.prototype.forEach.call(node.querySelectorAll('li'), function (li) {
            out.notas.push(li.innerHTML.trim());
          });
        } else {
          appendHTML(out, current, node.innerHTML ? node.innerHTML.trim() : node.textContent.trim());
        }
      }
    });
    return out;
  }

  function appendHTML(out, key, html) {
    if (key === 'notas') { out.notas.push(html); return; }
    out[key] = out[key] ? (out[key] + ' ' + html) : html;
  }
  function appendText(out, key, text) { appendHTML(out, key, text); }

  function buildNotasHTML(data) {
    if (!data.notas.length && !data.smell) return '';
    var html = '';
    data.notas.forEach(function (line) { html += '<p class="mp-notes__line">' + line + '</p>'; });
    if (data.smell) html += '<p class="mp-notes__smell"><strong>A qué huele:</strong> ' + data.smell + '</p>';
    return html;
  }
  function buildUsoHTML(data) {
    var html = '';
    if (data.uso) html += '<p>' + data.uso + '</p>';
    if (data.personalidad) html += '<p>' + data.personalidad + '</p>';
    return html;
  }

  function setContent(root, sel, html) {
    var el = root.querySelector(sel);
    if (!el) return false;
    if (html) { el.innerHTML = html; return true; }
    return false;
  }

  /* ---------- Distribuye el contenido en tabs y acordeones ---------- */
  function hydrateContent(root) {
    var source = root.querySelector('[data-mp-source]');
    if (!source) return;
    var data;
    try { data = parseDescription(source); } catch (e) { return; }

    var descHTML = data.desc ? '<p>' + data.desc + '</p>' : '';
    var notasHTML = buildNotasHTML(data);
    var usoHTML = buildUsoHTML(data);

    // Descripción corta (desktop) + tab desc + acordeón desc (mobile)
    if (descHTML) {
      setContent(root, '[data-mp-short]', descHTML);
      setContent(root, '[data-mp-panel="desc"]', '<div class="mp-rte">' + descHTML + '</div>');
    }
    setAccOrHide(root, 'desc', descHTML);

    // Notas -> tab + acordeón desktop
    var hasNotas = !!notasHTML;
    setPanelOrHide(root, 'notas', notasHTML);
    setAccOrHide(root, 'notas', notasHTML);

    // Uso -> tab + acordeón desktop
    setPanelOrHide(root, 'uso', usoHTML);
    setAccOrHide(root, 'uso', usoHTML);

    // Si notas quedó vacío y no hay más que la desc, dejamos la tab desc activa
    if (!hasNotas) deactivateTabIfEmpty(root, 'notas');
    if (!usoHTML) deactivateTabIfEmpty(root, 'uso');
  }

  function setPanelOrHide(root, key, html) {
    var panel = root.querySelector('[data-mp-panel="' + key + '"]');
    if (!panel) return;
    if (html) { panel.innerHTML = '<div class="mp-rte">' + html + '</div>'; }
    else { panel.setAttribute('hidden', ''); }
  }
  function setAccOrHide(root, key, html) {
    var acc = root.querySelector('[data-mp-acc="' + key + '"]');
    if (!acc) return;
    var body = acc.querySelector('.mp-acc__body');
    if (html && body) { body.innerHTML = '<div class="mp-rte">' + html + '</div>'; }
    else { acc.parentNode && acc.parentNode.removeChild(acc); }
  }
  function deactivateTabIfEmpty(root, key) {
    var tab = root.querySelector('[data-mp-tab="' + key + '"]');
    if (tab) tab.style.display = 'none';
  }

  /* ---------- Tabs ---------- */
  function initTabs(root) {
    var tabs = root.querySelectorAll('.mp-tab');
    if (!tabs.length) return;
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-mp-tab');
        root.querySelectorAll('.mp-tab').forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        root.querySelectorAll('.mp-tab-panel').forEach(function (p) {
          var active = p.getAttribute('data-mp-panel') === key;
          p.classList.toggle('is-active', active);
          if (active) p.removeAttribute('hidden'); else p.setAttribute('hidden', '');
        });
      });
    });
  }

  /* ---------- Galería: zoom desktop ---------- */
  function initGalleryZoom(root) {
    var overlay = root.querySelector('[data-mp-zoom-overlay]');
    var stage = root.querySelector('[data-mp-zoom-stage]');
    var closeBtn = root.querySelector('[data-mp-zoom-close]');
    if (!overlay || !stage) return;
    var isDesktop = function () { return window.matchMedia('(min-width: 1024px)').matches; };

    function open(index) {
      if (!isDesktop()) return;
      stage.innerHTML = '';
      root.querySelectorAll('[data-mp-zoom] img').forEach(function (img) {
        var full = document.createElement('img');
        full.src = img.currentSrc || img.src;
        var big = (img.getAttribute('srcset') || '').split(',').map(function (s) { return s.trim().split(' ')[0]; }).pop();
        if (big) full.src = big;
        full.alt = img.alt || '';
        full.loading = 'lazy';
        stage.appendChild(full);
      });
      overlay.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      var target = stage.children[index];
      if (target) target.scrollIntoView({ block: 'start' });
    }
    function close() {
      overlay.setAttribute('hidden', '');
      document.body.style.overflow = '';
    }

    root.querySelectorAll('[data-mp-zoom]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!isDesktop()) return;
        open(parseInt(btn.getAttribute('data-mp-index'), 10) || 0);
      });
    });
    if (closeBtn) closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !overlay.hasAttribute('hidden')) close(); });
  }

  /* ---------- Galería: indicador de carrusel mobile ---------- */
  function initGalleryProgress(root) {
    var gallery = root.querySelector('[data-mp-gallery]');
    var progress = root.querySelector('[data-mp-progress]');
    if (!gallery || !progress) return;
    var span = progress.querySelector('span');
    var items = gallery.querySelectorAll('.mp-gallery__item');
    if (!span || items.length < 2) { progress.style.display = 'none'; return; }
    var pct = 100 / items.length;
    span.style.width = pct + '%';
    function update() {
      var idx = Math.round(gallery.scrollLeft / gallery.clientWidth);
      idx = Math.max(0, Math.min(items.length - 1, idx));
      span.style.left = (idx * pct) + '%';
    }
    gallery.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    update();
  }

  /* ---------- Galería: flechas laterales prev/next ---------- */
  function initGalleryNav(root) {
    var gallery = root.querySelector('[data-mp-gallery]');
    var prev = root.querySelector('[data-mp-nav="prev"]');
    var next = root.querySelector('[data-mp-nav="next"]');
    if (!gallery || !prev || !next) return;
    var items = gallery.querySelectorAll('.mp-gallery__item');
    if (items.length < 2) { prev.hidden = true; next.hidden = true; return; }

    function step(dir) {
      gallery.scrollBy({ left: dir * gallery.clientWidth, behavior: 'smooth' });
    }
    prev.addEventListener('click', function (e) { e.stopPropagation(); step(-1); });
    next.addEventListener('click', function (e) { e.stopPropagation(); step(1); });

    function update() {
      var idx = Math.round(gallery.scrollLeft / gallery.clientWidth);
      idx = Math.max(0, Math.min(items.length - 1, idx));
      prev.hidden = idx <= 0;
      next.hidden = idx >= items.length - 1;
    }
    gallery.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- Galería: miniaturas (clic cambia la principal) ---------- */
  function initGalleryThumbs(root) {
    var gallery = root.querySelector('[data-mp-gallery]');
    var strip = root.querySelector('[data-mp-thumbs]');
    if (!gallery || !strip) return;
    var thumbs = strip.querySelectorAll('.mp-gallery__thumb');
    var items = gallery.querySelectorAll('.mp-gallery__item');
    if (thumbs.length < 2) return;

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        if (items[i]) gallery.scrollTo({ left: items[i].offsetLeft, behavior: 'smooth' });
      });
    });

    function update() {
      var idx = Math.round(gallery.scrollLeft / gallery.clientWidth);
      idx = Math.max(0, Math.min(thumbs.length - 1, idx));
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
      var active = thumbs[idx];
      if (active) {
        var target = active.offsetLeft - (strip.clientWidth - active.clientWidth) / 2;
        strip.scrollTo({ left: target, behavior: 'smooth' });
      }
    }
    gallery.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- Galería: arrastre con mouse (PC). Mobile arrastra nativo. ---------- */
  function initGalleryDrag(root) {
    var gallery = root.querySelector('[data-mp-gallery]');
    if (!gallery) return;
    var down = false, moved = false, startX = 0, startLeft = 0;

    gallery.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return; // táctil/trackpad: scroll nativo
      down = true; moved = false;
      startX = e.clientX; startLeft = gallery.scrollLeft;
      gallery.classList.add('mp-gallery--grabbing');
    });
    gallery.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 5) moved = true;
      gallery.scrollLeft = startLeft - dx;
    });
    function end() {
      if (!down) return;
      down = false;
      gallery.classList.remove('mp-gallery--grabbing'); // reactiva scroll-snap → encaja
    }
    gallery.addEventListener('pointerup', end);
    gallery.addEventListener('pointerleave', end);
    // Si hubo arrastre, tragarse el click para que NO abra el zoom.
    gallery.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
  }

  /* ---------- Barra sticky mobile ---------- */
  function initStickyBar(root) {
    var atc = root.querySelector('[data-mp-atc]');
    var bar = root.querySelector('[data-mp-stickybar]');
    if (!atc || !bar || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var show = !entry.isIntersecting && window.matchMedia('(max-width: 1023px)').matches;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
    }, { rootMargin: '0px 0px -80% 0px', threshold: 0 });
    io.observe(atc);
  }

  /* ---------- Bookmark ---------- */
  function initBookmark(root) {
    var bm = root.querySelector('[data-mp-bookmark]');
    if (!bm) return;
    bm.addEventListener('click', function () {
      var on = bm.getAttribute('aria-pressed') === 'true';
      bm.setAttribute('aria-pressed', on ? 'false' : 'true');
    });
  }

  /* ---------- Estados cosméticos del botón (add nativo) ---------- */
  function initButtonStates(scope) {
    // Botón principal
    scope.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
      var main = form.querySelector('[data-mp-atc]');
      if (main && !main.disabled) {
        main.classList.add('is-loading');
        var label = main.querySelector('.mp-atc__label');
        var original = label ? label.textContent : '';
        window.setTimeout(function () {
          main.classList.remove('is-loading');
          if (label) { label.textContent = 'AÑADIDO'; }
          window.setTimeout(function () { if (label) label.textContent = original; }, 2000);
        }, 900);
      }
      var add = form.querySelector('[data-mp-add]');
      if (add && !add.disabled) {
        add.classList.add('is-added');
        window.setTimeout(function () { add.classList.remove('is-added'); }, 2000);
      }
    }, true);
  }

  /* Nota: EasySell (botón COD inline "PAGA AL RECIBIR") se deja en su estado
     nativo por decisión del negocio; no se re-estiliza en esta plantilla. */

  /* ---------- Refresca el contador del carrito sin abrir el drawer ---------- */
  function refreshCartIconBubble() {
    fetch('/?sections=cart-icon-bubble')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data['cart-icon-bubble']) return;
        var el = document.getElementById('cart-icon-bubble');
        if (el) el.innerHTML = data['cart-icon-bubble'];
      })
      .catch(function () {});
  }

  /* ---------- Ritual: add-to-cart silencioso (NO abre el cart-drawer) ----------
     No usa <product-form> nativo a propósito: así el tema no abre el drawer y
     EasySell no inyecta su botón COD en estos upsells. Add directo por AJAX. */
  function initRitualAdd(scope) {
    scope.querySelectorAll('[data-mp-ritual-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.hasAttribute('disabled') || btn.classList.contains('is-loading')) return;
        var id = btn.getAttribute('data-variant-id');
        if (!id) return;
        btn.classList.add('is-loading');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: id, quantity: 1 })
        })
          .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
          .then(function () {
            btn.classList.remove('is-loading');
            btn.classList.add('is-added');
            window.setTimeout(function () { btn.classList.remove('is-added'); }, 2000);
            refreshCartIconBubble();
          })
          .catch(function () { btn.classList.remove('is-loading'); });
      });
    });
  }

  /* ---------- Init ---------- */
  function initMain(root) {
    hydrateContent(root);
    initTabs(root);
    initGalleryZoom(root);
    initGalleryProgress(root);
    initGalleryNav(root);
    initGalleryThumbs(root);
    initGalleryDrag(root);
    initStickyBar(root);
    initBookmark(root);
  }

  function boot() {
    document.querySelectorAll('.mp-root[data-mp-section]').forEach(initMain);
    initButtonStates(document);
    initRitualAdd(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Soporte para el editor de temas (re-render de secciones)
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector ? e.target.querySelector('.mp-root[data-mp-section]') : null;
    if (root) initMain(root);
  });
})();
